module.exports = __webpack_public_path__ + "img/w3_package_thin_grey.4391625e.png";